import * as React from 'react';
import {
  ResponsiveGridLayout,
  ResponsiveNavContainer,
  ResponsiveMainContainer,
} from 'components/global-layout';
import { LearnNavigation } from 'components/nav/learn-navigation';
import { GlobalMessageWrapper } from './global-message-wrapper';
import { AppFactory } from 'app/app-factory';
import { Navigate, useParams } from 'react-router-dom';
import { ReturnNavState } from 'components/nav/return-nav-state';
import { homePath } from 'components/nav/path-helpers';

export const LearnLayout: React.FC = ({ children }) => {
  const { l2 } = useParams<{ l2: string }>();

  const { webModeEnabled } = AppFactory.root.userManager;
  if (!webModeEnabled) {
    return <Navigate to={homePath()} replace />;
  }

  // capture state for when returning from account screen
  ReturnNavState.appMode = 'teach';
  ReturnNavState.l2 = l2;

  return (
    <>
      <ResponsiveGridLayout className="x-global-grid">
        <ResponsiveMainContainer>
          <GlobalMessageWrapper>{children}</GlobalMessageWrapper>
        </ResponsiveMainContainer>
        <ResponsiveNavContainer>
          <LearnNavigation />
        </ResponsiveNavContainer>
      </ResponsiveGridLayout>
    </>
  );
};
